import { useSelector } from 'react-redux'
import { UserRole } from 'shared/types'
import { getUserRole, getAuth } from 'shared/store/auth/selectors'

export const useUserRole = () => {
  const userType: UserRole = useSelector(getUserRole)
  const {
    currentUserInfo: { loading },
  } = useSelector(getAuth)

  const isAllowed = (allowed: UserRole | UserRole[]) => {
    if (Array.isArray(allowed)) return allowed.includes(userType)
    return allowed === userType
  }

  return {
    loading,
    userType,
    isAllowed,
  }
}
